<p class="text-muted mt-2" i18n>
  Die neuesten Ermittlungen der automatischen Kategorie- und MwSt.-Zuordnung. Fälle ohne
  eindeutiges Ergebnis sind das Rohmaterial der Pflege: ein Klick auf einen Begriff übernimmt
  ihn ins Formular oben — Bereich und Sprache werden aus der Beobachtung vorbelegt.
  Angezeigt werden höchstens die letzten {{ take }} Ermittlungen je Bereich.
</p>

<div class="row g-2 align-items-end border rounded p-3 mb-3 bg-light">
  <div class="col-sm-2">
    <label class="form-label col-form-label-sm mb-0" i18n>Bereich</label>
    <kendo-dropdownlist
      [data]="subjectItems"
      [value]="subject"
      textField="label"
      valueField="value"
      [valuePrimitive]="true"
      (valueChange)="onSubjectChange($event)"
    ></kendo-dropdownlist>
  </div>
  <div class="col-sm-4">
    <label class="form-label col-form-label-sm mb-0" i18n>Shop</label>
    <kendo-dropdownlist
      [data]="shopItems"
      [value]="selectedBindingId"
      textField="label"
      valueField="value"
      [valuePrimitive]="true"
      [defaultItem]="{ value: null, label: allShopsLabel }"
      (valueChange)="onShopChange($event)"
    ></kendo-dropdownlist>
  </div>
  <div class="col-sm-4">
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="openOnly"
        [checked]="openOnly"
        (change)="onToggleOpenOnly()"
      />
      <label class="form-check-label" for="openOnly" i18n>
        Nur offene Fälle (mehrdeutig / kein Treffer)
      </label>
    </div>
  </div>
  <div class="col-sm-2 text-end">
    <button class="btn btn-secondary btn-sm" type="button" (click)="reload()" i18n>
      Aktualisieren
    </button>
  </div>
</div>

<kendo-grid [data]="visibleRows" [resizable]="true">
  <ng-template kendoGridNoRecordsTemplate>
    <app-grid-no-records i18n-emptyText emptyText="Keine Beobachtungen vorhanden"></app-grid-no-records>
  </ng-template>

  <kendo-grid-column field="createdAt" i18n-title title="Zeit" format="{0:g}" [width]="140"></kendo-grid-column>

  <kendo-grid-column field="name" i18n-title title="Produkt">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div>{{ dataItem.name || '—' }}</div>
      @if (dataItem.gtin) {
        <small class="text-muted" i18n>GTIN {{ dataItem.gtin }}</small>
      }
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column i18n-title title="Begriff übernehmen">
    <ng-template kendoGridCellTemplate let-dataItem>
      @for (term of dataItem.termCandidates; track term) {
        <button
          type="button"
          class="btn btn-sm btn-outline-primary term-chip me-1 mb-1"
          [title]="term"
          (click)="onTakeOver(dataItem, term)"
        >
          {{ term }}
        </button>
      } @empty {
        <span class="text-muted">—</span>
      }
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="languageLabel" i18n-title title="Sprache" [width]="140"></kendo-grid-column>

  <kendo-grid-column field="outcomeLabel" i18n-title title="Ergebnis" [width]="220">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [title]="dataItem.evidenceSummary">
        @switch (dataItem.outcome) {
          @case ('Resolved') {
            <span class="badge bg-success">{{ dataItem.outcomeLabel }}</span>
          }
          @case ('Ambiguous') {
            <span class="badge bg-warning text-dark">{{ dataItem.outcomeLabel }}</span>
          }
          @default {
            <span class="badge bg-danger">{{ dataItem.outcomeLabel }}</span>
          }
        }
        @if (dataItem.resultLabel !== '—') {
          <span class="ms-1">{{ dataItem.resultLabel }}</span>
        }
      </span>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
